import React from 'react';
import Icon from '../../../components/AppIcon';

const capabilities = [
  {
    id: 'dsa',
    icon: 'Code2',
    title: 'FAANG-style DSA',
    description: 'Solve realistic problems covering Arrays, Trees, Graphs, DP, and Strings, complete with dynamic follow-up prompts.',
    badge: 'Coding'
  },
  {
    id: 'pressure',
    icon: 'Timer',
    title: 'Interview Pressure',
    description: 'Experience timed rounds, strict edge cases, and unexpected interviewer nudges that test your coding agility.',
    badge: 'Voice'
  },
  {
    id: 'ide',
    icon: 'Terminal',
    title: 'Integrated Coding IDE',
    description: 'Write, compile, and run code in Python, JavaScript, C++, or Go with direct console outputs and debugger tools.',
    badge: 'IDE'
  },
  {
    id: 'scorecard',
    icon: 'BarChart3',
    title: 'Scorecard Evaluation',
    description: 'Get immediate grades on correctness, time/space complexity, and communication style with clear action items.',
    badge: 'Analysis'
  }
];

const CapabilitiesSection = () => {
  return (
    <section 
      id="features" 
      className="relative border-t border-[var(--lp-line)] bg-[var(--lp-bg)] py-24 lg:py-32 overflow-hidden" 
      aria-labelledby="capabilities-heading"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8 font-sans">
        
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto space-y-4 mb-16 select-none">
          <h2 id="capabilities-heading" className="font-semibold text-3xl sm:text-4xl lg:text-5xl leading-[1.05] tracking-tight text-[var(--lp-ink)]">
            <span>Everything you need to </span>
            <span className="text-[var(--lp-accent)]">ace your technical rounds.</span>
          </h2>
          <p className="text-sm leading-relaxed text-[var(--lp-ink-soft)] max-w-2xl mx-auto text-balance">
            prepxai replicates the exact structure, environment, and evaluation criteria used by top-tier engineering companies to grade candidates.
          </p>
        </div>

        {/* Feature Cards Grid (4 Columns) */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {capabilities.map((item, idx) => (
            <div
              key={item.id}
              className="group relative flex flex-col p-6 bg-white dark:bg-[#111216] border border-[var(--lp-line)] rounded-2xl shadow-sm hover:border-emerald-500/30 dark:hover:border-emerald-500/20 hover:shadow-md hover:-translate-y-1 transition-all duration-300 min-h-[220px] justify-between cursor-default overflow-hidden"
            >
              {/* Card Ambient Glow (Hover) */}
              <div className="absolute inset-0 bg-gradient-to-tr from-emerald-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />

              <div>
                {/* Header Icon & Tag */}
                <div className="flex items-center justify-between mb-4 select-none">
                  <div className="w-9 h-9 rounded-xl bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 flex items-center justify-center">
                    <Icon name={item.icon} size={18} />
                  </div>
                  <span className="text-[9.5px]font-bold tracking-wider px-2 py-0.5 bg-slate-100 dark:bg-slate-800 text-[var(--lp-ink-soft)] rounded-md">
                    {item.badge}
                  </span>
                </div>

                {/* Content */}
                <div className="space-y-1.5">
                  <h3 className="text-sm font-bold text-[var(--lp-ink)] leading-snug group-hover:text-[var(--lp-accent)] transition-colors duration-200">
                    {item.title}
                  </h3>
                  <p className="text-[12px] leading-relaxed text-[var(--lp-ink-soft)] font-sans">
                    {item.description}
                  </p>
                </div>
              </div>

              {/* Bottom detail indicator */}
              <div className="flex justify-end mt-4 select-none">
                <Icon 
                  name="ArrowUpRight" 
                  size={14} 
                  className="text-emerald-500 transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200" 
                />
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default CapabilitiesSection;
